export {
  initClientTrackers,
  trackTime,
} from '@wallbox/metrics'

import {
  trackAction as _trackAction,
  trackEvent as _trackEvent,
  trackScreen as _trackScreen,
  trackError as _trackError,
} from '@wallbox/metrics'
import { telemetryTrack } from '@/engine/metrics/TelemetryTracker'

export const trackAction = (eventName: string, params?: Record<string, unknown>): void => {
  _trackAction(eventName, params)
  telemetryTrack(`action_${eventName}`, params)
}

export const trackEvent = (eventName: string, params?: Record<string, unknown>): void => {
  _trackEvent(eventName, params)
  telemetryTrack(`event_${eventName}`, params)
}

export const trackScreen = (eventName: string, params?: Record<string, unknown>): void => {
  _trackScreen(eventName, params)
  telemetryTrack(`screen_${eventName}`, params)
}

export const trackError = (eventName: string, params?: Record<string, unknown>): void => {
  _trackError(eventName, params)
  telemetryTrack(`error_${eventName}`, params)
}
